import React from 'react'
import {
    Typography,
    Grid
  } from '@mui/material';

import useStyles from '../styles';

export default function Errors(props) {
    const {errors} = props;
    const classes = useStyles();
    return (
        <div>
            <Grid container spacing={3} >
                <Grid item xs={12}>
                        <Typography variant="h6" color="primary">
                            Something went wrong... please try again!
                        </Typography>
                        <Typography variant="p" color="primary">
                            {errors && errors.map(error=>
                                <p>{error.message}</p>
                            )}                                
                        </Typography>
                </Grid>
            </Grid>
        </div>
    )
}